import { Controller as BaseController } from "@hotwired/stimulus"

export class Controller extends BaseController {
  static values = {
    inputId: String
  }

  suggest(event) {
    event.preventDefault()

    const input = document.getElementById(this.inputIdValue)
    if (!input) return

    const value = event.currentTarget.dataset.value
    const values = input.value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)

    if (!values.includes(value)) {
      values.push(value)
    }

    input.value = values.join(", ")
    input.focus()
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
